export enum OpportunityProcessTypeEnum {
  BASIC = '1aee0188-b8c1-49b6-96c7-861a667f498e',
  DETAILED = '3a343c9c-c633-42b0-ad41-ed0246e35755',
}
